import { Directive, Input, OnDestroy, AfterViewInit, Host, Optional, Self, OnInit } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'mat-paginator[persistPaginator]',
  standalone: false,
})
export class PersistPaginatorDirective implements OnInit, AfterViewInit, OnDestroy {
  @Input('persistPaginator') storageKey!: string;
  private subscription!: Subscription;

  constructor(@Host() @Self() @Optional() private readonly matPag: MatPaginator) {}

  ngOnInit() {
    const storedPageSize = Number(localStorage.getItem(this.storageKey));
    this.matPag.pageSize = Number.isFinite(storedPageSize) && storedPageSize > 0 ? storedPageSize : 25;
  }

  ngAfterViewInit() {
    this.subscription = this.matPag.page.subscribe((event: PageEvent) => {
      localStorage.setItem(this.storageKey, event.pageSize.toString());
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
